export default __webpack_public_path__ + "static/SRF 0030SG - Fiche de spécifications et données techniques-caeb7fa3af967205b6e76afdb8bb03ee.pdf";